import { RestLink } from 'apollo-link-rest'
import gql from 'graphql-tag'

import { createPathHelper } from '@/modules/module-factory-dashboard/queries/createPathHelper'

export function createEntityListPath({ args, exportVariables }: RestLink.PathBuilderProps) {
  const qs = createPathHelper(args, exportVariables)
  return '/entity-list' + qs
}

export const GET_ENTITY_LIST_QUERY = gql`
  query entity_list(
    $ids: [ID]!
    $level: Float
    $depth: Int
    $type: [ID]
    $group: [ID]
    $pathFunction: any
  ) {
    entity_list(ids: $ids, level: $level, depth: $depth, type: $type, group: $group)
      @rest(type: "EntityList", pathBuilder: $pathFunction) {
      id
      entity_type_id
      name
      attributes
      tree_path
      geom
      level
    }
  }
`
